<template>
    <div class="py-4">
        <modal-filter :onfilter="onfilter" :filter="filter" @onclose="onfilter = false" @onfilter="INIT()" :exclude="['state_id', 'payment_state_id']"/>
        <header>
            <div class="container-fluid">
                <div class="pb-4">
                    <div class="row align-items-end">
                        <div class="col-sm col-12">
                            <h1 class="h2 ls-tight">Exenciones</h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="vstack gap-4">
                    <div class="d-flex flex-column flex-md-row gap-3 justify-content-between">
                        <form class="d-flex gap-3 row" @submit.prevent="FILTER()">
                            <div>
                                <button @click="onfilter = true" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="bi bi-funnel me-2"></i>
                                    <span>Filtro</span>
                                    <span class="vr opacity-20 mx-3"></span>
                                    <span class="text-xs text-primary">{{ count_filter }}</span>
                                </button>
                            </div>
                            <div>
                                <button @click="SORT()" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="me-2" :class="filter.sortDesc == 'ASC' ? 'bi bi-sort-alpha-up' : 'bi bi-sort-alpha-down-alt'"></i>
                                    <span>{{ filter.sortDesc }}</span>
                                </button>
                            </div>
                            <div class="col-md-4 px-0">
                                <div class="input-group input-group-sm input-group-inline">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text pe-2 text-sm"><i class="bi bi-search"></i></span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="Buscar..." v-model="filter.search">
                                </div>
                            </div>
                            <div>
                                <button type="submit" class="btn btn-h px-3 btn-primary">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'table' && loading_two == 'filter'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Buscar</span>
                                </button>
                            </div>
                            <div>
                                <button type="button" class="btn btn-h px-3 btn-danger" @click="CLEAR()">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'table' && loading_two == 'clear'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Limpiar</span>
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card">
                        <div class="card-header bg-white">
                            <h5 class="me-auto">Listado</h5>
                        </div>
                        <div class="card-body p-0">
                            <template>
                                <v-data-table  class="elevation-1"
                                    :headers="headers"
                                    :items="loading == 'table' ? [] :items.data"
                                    :options.sync="options"
                                    :server-items-length="items.total"
                                    :loading="loading == 'table'"
                                    :footer-props="{
                                        'items-per-page-options': [5, 10, 50, 100]
                                    }">
                                    <template v-slot:[`item.id`]="{ item }">
                                        {{
                                            items.to >= 10 ? items.to - options.itemsPerPage + items.data.indexOf(item) +
                                                1 : items.data.indexOf(item) + 1
                                        }}
                                    </template>
                                    <template v-slot:[`item.id`]="{ item }">
                                        {{ item.type }}{{ item.id }}
                                    </template>
                                    <template v-slot:[`item.created_at`]="{ item }">
                                        {{ item.created_at | DATE }}
                                    </template>
                                    <template v-slot:[`item.value`]="{ item }">
                                        {{ Number(String(item.value)).toFixed(2) }}
                                    </template>
                                    <template v-slot:[`item.shipping`]="{ item }">
                                        {{ Number(String(item.shipping)).toFixed(2) }}
                                    </template>
                                    <template v-slot:[`item.segure`]="{ item }">
                                        {{ Number(String(item.value/100)).toFixed(2) }}
                                    </template>
                                    <template v-slot:[`item.total`]="{ item }">
                                        {{ Number(String(item.value + (item.value/100) + item.shipping)).toFixed(2) }}
                                    </template>
                                    <template v-slot:[`item.state.name`]="{ item }">
                                        <span class="badge badge-pill" :class="item.state.labels ? item.state.labels : 'badge-light'">{{ item.state.name }}</span>
                                    </template>
                                    <template v-slot:[`item.exemption`]="{ item }">
                                        <span class="badge badge-pill badge-dark pb-1">{{ item.exemption | EXEMPTION }}</span>
                                    </template>
                                    <template v-slot:[`item.description`]="{ item }">
                                        <v-tooltip bottom class="mx-1">
                                            <template v-slot:activator="{ on, attrs }">
                                                <div v-bind="attrs" v-on="on" class="nowrap" v-if="Array.isArray(item.description)">
                                                    {{ item.description[0] }} ...
                                                </div>
                                            </template>
                                            <small><div v-for="(description, key) in  item.description" :key="key">{{ description }}</div></small>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.actions`]="{ item }">
                                        <div class="d-flex">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <button @click="ACTION(item, EXEMPTION_VALUE(item.exemption))"
                                                        type="button"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="btn btn-h mr-2" :class="item.exemption | EXEMPTION_COLOR">
                                                        <small>{{ item.exemption | EXEMPTION_PREVIEW }}</small>
                                                    </button>
                                                </template>
                                                <small>Aprobar</small>
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <button @click="ACTION(item, 'denied')"
                                                        type="button"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="btn btn-h btn-danger">
                                                        <small>Denegar</small>
                                                    </button>
                                                </template>
                                                <small>Denegar</small>
                                            </v-tooltip>
                                        </div>
                                    </template>
                                </v-data-table>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import ModalFilter from './modals/Filter'
export default {
    components: { ModalFilter },
    data() {
        return {
            headers: [
                { text: 'GV', value: 'user.id', sortable: false },
                { text: 'Fecha de Creación', value: 'created_at', sortable: false },
                { text: 'Identificación', value: 'user.identification', sortable: false },
                { text: 'Cliente', value: 'user.name', sortable: false },
                { text: 'GVT', value: 'id', sortable: false },
                { text: 'Descripción', value: 'description', sortable: false },
                { text: 'Valor', value: 'value', sortable: false },
                { text: 'Flete', value: 'shipping', sortable: false },
                { text: 'Seguro', value: 'segure', sortable: false },
                { text: 'Total (CIF)', value: 'total', sortable: false },
                { text: 'Estado Paquete', value: 'state.name', sortable: false },
                { text: 'Estado Exención', value: 'exemption', sortable: false },
                { text: 'Acciones', value: 'actions', sortable: false },
            ],
            items: {
                data: [],
                total: 0,
                to: 0
            },
            loading: '',
            loading_two: '',
            options: {},
            filter: {
                operator: 'LIKE',
                sortBy: 'id',
                sortDesc: 'ASC',
                fields: ['id', 'tracking', 'description'],
                search: ''
            },
            onfilter: false,
            id: null,
            count: 0,
        }
    },
    computed: {
        count_filter: function(){
            let count = 0;
            let vue = this
            Object.entries(vue.filter).forEach((e) => {
                if(e[0] != 'sortBy' && e[0] != 'sortDesc' && e[0] != 'search'){
                    if(typeof e[1] == 'object'){
                        if(e[1]){
                            if(e[1].length > 0){
                                count++
                            }
                        }
                    }else{
                        if(e[1]){
                            count++
                        }
                    }   
                }
            })
            return count;
        }
    },
    methods: {
        EXEMPTION_VALUE: function(value){
            if(value == 'requested'){
                return 'documents'
            }else if(value == 'documents'){
                return 'preapproved'
            }else if(value == 'preapproved'){
                return 'approved'
            }else{
                return 'approved'
            }
        },
        INIT: function () {
            let vue = this
            vue.loading = 'table'
            const { page, itemsPerPage } = vue.options
            let query = {
                page: page,
                itemsPerPage: itemsPerPage,
            }
            Object.entries(vue.filter).forEach((e) => {
                query[e[0]] = e[1]
            })
            axios({
                url: '/exemptions',
                method: 'GET',
                params: query
            })
                .then((resp) => {
                    vue.items = resp.data
                })
                .catch((err) => {
                    if (err.response.status === 402) {
                       let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    } else {
                        vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }
                })
                .finally((resp) => {
                    vue.loading = ''
                    vue.loading_two = ''
                    vue.onfilter = false
                })
        },
        SORT: function() {
            let vue = this
            vue.filter.sortDesc = vue.filter.sortDesc == 'ASC' ? 'DESC' : 'ASC'
            vue.INIT()
        },
        FILTER: function(){
            let vue = this
            let count = 0
            if(vue.filter.search.length > 0){
                count++
            }
            if(count > 0){
                vue.loading_two = 'filter'
                vue.INIT()
            }
        },
        CLEAR: function(){
            let vue = this
            vue.loading_two = 'clear'
            vue.filter = {
                operator: 'LIKE',
                sortBy: 'id',
                sortDesc: 'ASC',
                fields: ['id', 'tracking', 'description'],
                search: ''
            }
            vue.INIT()
        },
        ACTION: function(item, option){
            let vue = this
            vue.count++
            if(vue.count == 1){
                let data = {
                    status: option
                }
                axios({url: '/exemptions/' + item.id, method: 'PUT', data: data })
                .then((resp) => {
                    vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    vue.INIT()
                })
                .catch((err) => {
                    if(err.response.status !== 422){
                        let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    } else {
                        vue.errors = err.response.data
                    }
                })
                .finally((resp)=>{
                    vue.count = 0
                })
            }
        },
    },
    watch: {
        options: {
            handler() {
                this.INIT()
            },
            deep: true
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/packages/Exemptions.vue